import React from 'react';

import { colors, Container, Row, Col } from '@crehana/ui';
import {
  Twitter,
  Facebook,
  Instagram,
  Linkedin,
  Youtube,
  CrehanaLogo,
} from '@crehana/icons';

import { useCrehanaLiveTranslations } from 'Jsx/CrehanaLive/hooks';

export const SOCIAL_NETWORKS = [
  {
    link: 'https://www.facebook.com/Crehanacom/',
    Icon: Facebook,
  },
  {
    link: 'https://twitter.com/crehanacom',
    Icon: Twitter,
  },
  {
    link: 'https://www.instagram.com/crehanacom/',
    Icon: Instagram,
  },
  {
    link: 'https://www.linkedin.com/school/crehana/',
    Icon: Linkedin,
  },
  {
    link: 'https://www.youtube.com/channel/UCg6_yPdtalblZ0Peqjv5rPg/featured',
    Icon: Youtube,
  },
];

const B2BFooter = () => {
  const { t } = useCrehanaLiveTranslations();

  return (
    <footer className="hidden sm:block bg-base-main">
      <Container>
        <Row>
          <Col xs={6} lg={4} className="flex items-center">
            <p className="font-legals text-white mr-8">{t('PRODUCT_B2B')}</p>
            <CrehanaLogo size={16} color={colors.white} />
          </Col>

          <Col
            xs={6}
            lg={4}
            className="flex items-baseline justify-end lg:justify-center"
          >
            <a
              href="https://ayuda.crehana.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="mr-24"
            >
              <p className="font-caption text-white">{t('NEED_HELP')}</p>
            </a>
            <p className="font-caption text-white mr-8">{t('FOLLOW_US')}</p>
            {SOCIAL_NETWORKS.map(({ link, Icon }) => (
              <a
                key={link}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon size={12} color={colors.white} className="mr-8" />
              </a>
            ))}
          </Col>
          <Col xs={12} lg={4}>
            <p className="font-legals text-white">
              Copyright © Crehana {new Date().getFullYear()} -{t('COPYRIGTH')}
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default B2BFooter;
